import { TableColumn } from 'react-data-table-component';

interface IProps {
  nome: string;
}

export const makeColumnsCourse = (): TableColumn<IProps>[] => {
  return [
    {
      name: 'Nome',
      selector: (row) => row.nome,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
  ];
};
